export const CURATED_COLLECTION_EVENT_NAMES = {
  VIEWED: 'Viewed Curated Collection',
  EXPANDED_DESCRIPTION: 'Expanded Collection Description',
  CLICKED_TOC: 'Clicked Curated Collection TOC',
  CLICKED_STRATEGY: 'Clicked Curated Collection Strategy',
  CLICKED_EXTERNAL_LINK: 'Clicked External Link'
}
